import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "row"];

  filterTable(event) {
    const searchTerm = event.target.value.toLowerCase();

    this.rowTargets.forEach(row => {
      const text = row.textContent.toLowerCase();
      row.style.display = text.includes(searchTerm) ? "table-row" : "none";
    });
  }
}
